export const Authentication = () =>{
    const accessToken = localStorage.getItem('accessToken');
    return accessToken? true : false;
} 